<template>
  <nav
    id="header"
    class="fixed w-full z-50 top-0 transition-all duration-300"
    :class="scrolled ? 'nav-scrolled' : 'bg-transparent'"
  >
    <div class="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
      <a href="#top" class="group">
        <span
          class="font-serif text-2xl tracking-wide transition-colors duration-200"
          :class="scrolled ? 'text-charcoal' : 'text-charcoal'"
        >Carina Landin</span>
      </a>

      <ul class="hidden md:flex items-center gap-8">
        <li v-for="link in links" :key="link.href">
          <a
            :href="link.href"
            class="text-xs font-medium tracking-widest uppercase transition-colors duration-200"
            :class="scrolled ? 'text-muted hover:text-terra' : 'text-muted hover:text-terra'"
          >{{ link.label }}</a>
        </li>
        <li>
          <a href="mailto:carina@carinalandin.se" class="btn-primary text-xs py-2 px-5">Kontakta mig</a>
        </li>
      </ul>

      <button
        class="md:hidden flex flex-col gap-1.5 p-2"
        @click="menuOpen = !menuOpen"
        aria-label="Meny"
      >
        <span class="block w-6 h-0.5 bg-charcoal transition-all duration-200" :class="menuOpen ? 'rotate-45 translate-y-2' : ''"></span>
        <span class="block w-6 h-0.5 bg-charcoal transition-all duration-200" :class="menuOpen ? 'opacity-0' : ''"></span>
        <span class="block w-6 h-0.5 bg-charcoal transition-all duration-200" :class="menuOpen ? '-rotate-45 -translate-y-2' : ''"></span>
      </button>
    </div>

    <div
      v-if="menuOpen"
      class="md:hidden bg-cream border-t border-sand px-6 py-6 flex flex-col gap-5"
    >
      <a
        v-for="link in links"
        :key="link.href"
        :href="link.href"
        class="text-xs font-medium tracking-widest uppercase text-muted hover:text-terra transition-colors"
        @click="menuOpen = false"
      >{{ link.label }}</a>
      <a href="mailto:carina@carinalandin.se" class="btn-primary text-center text-xs" @click="menuOpen = false">Kontakta mig</a>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      scrolled: false,
      menuOpen: false,
      links: [
        { href: '#om-mig',      label: 'Om mig' },
        { href: '#tjanster',    label: 'Tjänster' },
        { href: '#utbildning',  label: 'Utbildning' },
      ],
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 40;
    },
  },
};
</script>
